import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { resetStore } from 'src/store';
import { getSchemeListByCompanyId } from 'src/api/employerHub/scheme';
import { SchemeResponse } from 'src/types';

type SchemeState = {
  isLoading: boolean;
  schemeList: SchemeResponse[];
};

export const fetchSchemeListByCompanyAction = createAsyncThunk(
  'scheme/fetchSchemeListByCompany',
  async (companyId: string) => {
    const res = await getSchemeListByCompanyId(companyId);
    return res.data;
  },
);

const initialState: SchemeState = {
  isLoading: false,
  schemeList: [],
};

const schemeSlice = createSlice({
  name: 'scheme',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // SuperAdmin
    builder.addCase(fetchSchemeListByCompanyAction.pending, (state: SchemeState) => {
      state.isLoading = true;
      state.schemeList = [];
    });
    builder.addCase(fetchSchemeListByCompanyAction.fulfilled, (state: SchemeState, action) => {
      state.isLoading = false;
      state.schemeList = action.payload;
    });
    builder.addCase(fetchSchemeListByCompanyAction.rejected, (state: SchemeState) => {
      state.isLoading = false;
    });

    // Cleanup
    builder.addCase(resetStore, (state: SchemeState) => {
      Object.assign(state, initialState);
    });
  },
});

export default schemeSlice.reducer;
